import { Sparkle } from "lucide-react";

const phrases = ["Sonhe", "Planeje", "Crie", "Conquiste", "Do Zero ao Primeiro Cliente", "Método Prático", "Sem Complicação"];

const Marquee = () => {
  const row = [...phrases, ...phrases];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-[rgba(212,175,55,0.18)] bg-[#0d0d0d] py-7">
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((phrase, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif-display whitespace-nowrap px-8 text-2xl italic text-[rgba(243,229,171,0.5)] sm:text-3xl">
                  {phrase}
                </span>
                <Sparkle className="h-4 w-4 shrink-0 text-[#D4AF37]" fill="#D4AF37" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
